import { Injectable } from "@angular/core";
import { RequestMethodsService } from "../../commons/request_methods";
import { Constants } from "../../commons/constants";
import { Observable } from "rxjs/Observable";
import { Storage } from "@ionic/storage";
import { HttpHeaders, HttpClient } from "@angular/common/http";

@Injectable()
export class LoginService {
  constructor(private constants: Constants, private storage: Storage, private http: HttpClient) { }

  encodeAuth() {}

  callLoginApi(username, password): Observable<any> {
    let IMS_HEADERS = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Basic ${this.encodeAuth()}`
    }
    let headers = new HttpHeaders(IMS_HEADERS);
    let body = {
      grant_type: 'password',
      scope: 'read write securityapi_all',
      username: username,
      password: password
    };

    let httpMethod = this.http.post(`${this.constants.IMS_HOST}/connect/token`, `${this.serializeParams(body)}`, { headers: headers });

    return httpMethod
      .map((response: Response) => {
        return response;
      })
      .catch((error: Response) => {
        if (error.status == 400) {
          return Observable.throw(new Error("Username or password is incorrect."))
        }
        else {
          return Observable.throw(new Error("Something went wrong. Please try again."))
        }
      });
  }

  logout() {
    this.storage.clear();
  }

  handleError(error) {
    console.log(error);
  }

  storeAuthToken(token) {
    window.sessionStorage.setItem('authToken', token);
    this.storage.set('access_token', token);
  }

  retrieveAuthToken() {
    return this.storage.get('authToken').then((result) => {
      return result;
    });
  }

  serializeParams(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  validateToken(token) {

    let httpMethod = this.http.get(`${this.constants.IMS_HOST}/connect/accesstokenvalidation?token=${token}`);

    return httpMethod
      .map((response: Response) => {
        return response.json();
      })
      .catch((error: Response) => {
        return error.json();
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/login/login.service.ts